import { AttachFileOutlined, WarningAmberOutlined } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { blue, orange, red } from "@mui/material/colors";

const CellRendererRequirementType = ({ value, fontSize = "11px" }) => {
  const config = {
    Document: {
      color: blue[700],
      bg: blue[50],
      border: `1px solid ${blue[100]}`,
      icon: (
        <AttachFileOutlined
          sx={{ color: `${blue[700]} !important`, fontSize: "13px !important" }}
        />
      ),
    },
    Condition: {
      color: orange[700],
      bg: orange[50],
      border: `1px solid ${orange[100]}`,

      icon: (
        <WarningAmberOutlined
          sx={{
            color: `${orange[700]} !important`,
            fontSize: "13px !important",
          }}
        />
      ),
    },
    Stip: {
      color: red[700],
      bg: red[50],
      border: `1px solid ${red[100]}`,
      icon: "📌",
    },
  };

  const style = config[value] || config.Condition;

  return (
    <Chip
      label={value || "Condition"}
      icon={style.icon}
      size="small"
      sx={{
        backgroundColor: style.bg,
        color: style.color,
        fontWeight: 600,
        border: style.border,
        fontSize: fontSize,
      }}
    />
  );
};

export default CellRendererRequirementType;
